import { createPostEndpoint, HttpHeader } from '@sonar-software/sonar-http';

export type PostReindexCustomerRequest = {
	customerId: number;
	shardName?: string;
};

export const postReindexCustomer = createPostEndpoint<PostReindexCustomerRequest, void>(
	(request) => `/api/v3/core/search/reindex-customer/${request?.customerId}`,
	{
		headers: (request) => {
			if (request?.shardName) {
				return { [ HttpHeader.Shard ]: request.shardName };
			}

			return {};
		},
		skipAuthRefresh: true
	}
);
